// extracted by mini-css-extract-plugin
module.exports = {"orderlist_conatiner":"Order_orderlist_conatiner__3egqg","items":"Order_items__3Uf99","display_name":"Order_display_name__1mXU5"};